import ApiService, { HTTPMethod } from './api.core'
import { FirebaseService, FirebaseConfigKey } from '../services/FirebaseService'

class VehiclesApi {
  async addVehicle(values) {
    return ApiService.fetch('users/me/vehicles', HTTPMethod.POST, {
      year: values.year,
      make: values.make,
      model: values.model,
      engine_cc: values.engine_cc,
      zip: values.zip,
      acquired_year: values.acquired_year,
      less_than_year_acquired:
        values.less_than_year_acquired == 'true' ? true : false,
      accessory_value: values.accessory_value,
      side_car_value: values.side_car_value,
      value: values.value,
      miles_per_year: values.miles_per_year,
      anti_theft_device: values.anti_theft_device == 'yes',
      trailer_value: values.trailer_value,
      anti_lock_brakes: values.anti_lock_brakes == 'yes',
      vin: '12312',
    })
  }

  async deleteVehicle(vehicleId) {
    return ApiService.fetch('users/me/vehicles', HTTPMethod.DELETE, {
      user_vehicle_id: vehicleId,
    })
  }

  async updateVehicle(values) {
    return ApiService.fetch(`users/me/vehicles/${values.id}`, HTTPMethod.PUT, {
      year: values.year,
      model: values.model,
      make: values.make,
      engine_cc: values.engine_cc,
      side_car_value: values.side_car_value,
      zip: values.zip,
      less_than_year_acquired:
        values.less_than_year_acquired == 'true' ? true : false,
      accessory_value: values.accessory_value,
      value: values.value,
      trailer_value: values.trailer_value,
      miles_per_year: values.miles_per_year,
      anti_theft_device: values.anti_theft_device == 'yes',
      anti_lock_brakes: values.anti_lock_brakes == 'yes',
      vin: '12312',
    })
  }
}

export default new VehiclesApi()
